// ShortDrama web — entry. Vanilla TS, no UI framework. 04-web v2.0.
import { route, setNotFound, startRouter } from "./core/router.js";
import { isAuthenticated } from "./core/tokens.js";
import { h, mount } from "./core/dom.js";
import { applyStaticI18n, getLang, t, toggleLang } from "./core/i18n.js";
import { feedView } from "./features/feed.js";
import { titleView } from "./features/title.js";
import { playerView } from "./features/player.js";
import { shortsView } from "./features/shorts.js";
import { loginView } from "./features/auth.js";
import { callbackView } from "./features/oauth.js";
import { uploadView } from "./features/upload.js";
import { editorView } from "./features/editor.js";
import { libraryView } from "./features/library.js";
import { searchView } from "./features/search.js";
import { profileView } from "./features/profile.js";

function home(_p: Record<string, string>, root: HTMLElement): void {
  if (isAuthenticated()) void feedView(_p, root);
  else loginView(_p, root);
}

route("/", home);
route("/feed", feedView);
route("/login", loginView);
route("/t/:id", titleView);
route("/watch/:cutId", playerView);
route("/shorts", shortsView);
route("/shorts/:id", playerView); // single short detail reuses player shell (TODO short player)
route("/auth/callback", callbackView);
route("/upload", uploadView);
route("/edit/:episodeId", editorView);
route("/search", searchView);
route("/me", libraryView);
route("/me/cuts", libraryView);
route("/u/:handle", profileView);

setNotFound((_p, root) => mount(root, h("div", { class: "center muted" }, t("common.notFound"))));

// Translate static chrome (nav links carry data-i18n keys).
applyStaticI18n();

// Reflect auth state in the nav.
const authLink = document.getElementById("nav-auth");
if (authLink instanceof HTMLAnchorElement) {
  const authed = isAuthenticated();
  authLink.textContent = authed ? t("nav.me") : t("nav.login");
  authLink.setAttribute("href", authed ? "/me" : "/login");
}

// Language toggle (ko ⇄ en); reloads to re-render every screen consistently.
const langToggle = document.getElementById("lang-toggle");
if (langToggle instanceof HTMLButtonElement) {
  const target = getLang() === "ko" ? "English" : "한국어";
  langToggle.textContent = t("nav.lang");
  langToggle.title = target;
  langToggle.setAttribute("aria-label", target);
  langToggle.addEventListener("click", () => toggleLang());
}

// Close the mobile nav after navigating (the nav toggle is a CSS-only checkbox).
document.addEventListener("click", (e) => {
  const link = (e.target as HTMLElement).closest(".nav a[data-link]");
  if (!link) return;
  const toggle = document.getElementById("nav-toggle");
  if (toggle instanceof HTMLInputElement) toggle.checked = false;
});

startRouter();

// Register the service worker for app-shell caching (PWA). Best-effort.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js").catch(() => {
      /* offline support unavailable; app still works online */
    });
  });
}
